import { useState, useEffect, ReactNode } from 'react';
import NavBottomBar from './NavBottomBar';
import NavSidebar from './NavSidebar';
import styles from './ResponsiveLayout.module.css';

interface ResponsiveLayoutProps {
  children: ReactNode;
  fullScreen?: boolean;
}

const ResponsiveLayout: React.FC<ResponsiveLayoutProps> = ({ 
  children, 
  fullScreen = false 
}) => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);
  const [sidebarExpanded, setSidebarExpanded] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSidebarToggle = (expanded: boolean): void => {
    setSidebarExpanded(expanded);
    
    // Dispatch a custom event to notify child components of sidebar change
    const event = new CustomEvent('sidebarToggle', { 
      detail: { expanded } 
    });
    window.dispatchEvent(event);
  };

  return (
    <div className={styles.layout}>
      {!isMobile && (
        <NavSidebar 
          onToggleExpanded={handleSidebarToggle} 
        />
      )}
      <div 
        className={`
          ${styles.content} 
          ${isMobile ? '' : styles.withSidebar} 
          ${sidebarExpanded ? styles.withExpandedSidebar : ''} 
          ${fullScreen ? styles.fullScreen : ''}
        `}
      >
        {children}
      </div>
      {isMobile && <NavBottomBar />}
    </div>
  );
};

export default ResponsiveLayout; 